import { createSlice } from "@reduxjs/toolkit";

const customerFreelancerLinkDetailsSlice = createSlice({
    name: 'customerFreelancerLinkDetails',
    initialState: {
        data: null,
    },
    reducers: {
        setCustomerFreelancerLinkDetails: (state, action) => {
            state.data = action.payload;
        },
        clearCustomerFreelancerLinkDetails: (state) => {
            state.data = null;
        },
    },
})

export const { setCustomerFreelancerLinkDetails, clearCustomerFreelancerLinkDetails } = customerFreelancerLinkDetailsSlice.actions;
export default customerFreelancerLinkDetailsSlice.reducer;
